import React from 'react';
import { cx } from './utils';

export default function Button({
  variant = 'primary',
  size = 'md',
  as: Comp = 'button',
  className,
  ...props
}) {
  return (
    <Comp
      className={cx('btn', `btn--${variant}`, `btn--${size}`, className)}
      {...props}
    />
  );
}
